export const UNIT_TEST = typeof process !== 'undefined' && process.env && process.env.VITEST === 'true';
export const INTEGRATION_TEST =
  !!(globalThis as any).Cypress || (globalThis as any).localStorage?.getItem('integration') === 'true';
